import * as types from '@/redux/actionTypes';

const initState = {};

function me(state = initState, action) {
  switch (action.type) {
    case types.UPDATE_ME: {
      return action.payload;
    }

    default:
      return state;
  }
}

export default me;
